const ArrowLeft = () => (
  <svg width={6} height={12} viewBox="0 0 6 12" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.08248 5.09763L1.17689 0.241859C0.945684 -0.0454505 0.535049 -0.0832886 0.259628 0.157649C-0.0156042 0.398906 -0.0517091 0.82719 0.17949 1.1148L3.85248 5.68118L0.153703 10.1925C-0.0795312 10.4772 -0.043237 10.9011 0.234764 11.1398C0.512575 11.3786 0.927084 11.3414 1.16013 11.0569L5.10145 6.25001C5.24815 6.07107 5.28822 5.83674 5.22857 5.62816C5.2532 5.44432 5.2059 5.25084 5.08248 5.09763Z"
      fill="black"
    />
  </svg>
);

export default ArrowLeft;
